// Phase F7 — ONE main audio at a time across Nymia (Racconti + Audio Avatar).
// Tiny module singleton: whoever starts playing claims the bus and the
// previous handle gets paused. No events, no context — just a handle swap.
let current = null;

export const claimAudio = (handle) => {
  if (current && current !== handle) {
    try { current.pause(); } catch { /* noop */ }
  }
  current = handle;
};

export const releaseAudio = (handle) => {
  if (current === handle) current = null;
};
